import "../App.css";
import NumberOfMentions from "../components/NumberOfMentions";
import BestSources from "../components/BestSources";
import PublicTop from "../components/PubicTop";
import Metrics from "../components/Metrics";
import MediaIndex from "../components/MediaIndex";
import Calendar from "../components/Calendar";
import { useAppDispatch } from "../redux/store/hooks";
import {
  logoutAuth,
  resetFeedFilter,
  setProduct,
  setProducts,
  setReferences,
  setReferencesFilter,
} from "../redux/actions";
import { useEffect } from "react";
import { referencesService } from "../api";
import { useSelector } from "react-redux";
import { getMainProduct, getProduct } from "../redux/selectors";

function Main() {
  const dispatch = useAppDispatch();
  dispatch(resetFeedFilter());
  const mainProduct = useSelector(getMainProduct);
  const product = useSelector(getProduct);

  useEffect(() => {
    if (mainProduct)
    (referencesService
      .loadClientProducts()
      .then((resp) => {
        dispatch(setProducts(resp));
        dispatch(setReferencesFilter([mainProduct?.client?.id]));
        dispatch(setReferences([mainProduct?.client?.id]));
        if (product == null) dispatch(setProduct(mainProduct?.id));
      })
      .catch((err) => {
        dispatch(logoutAuth());
      }))
  }, [mainProduct]);

  return (
    <div className="App">
      <h1>{window.location.pathname.includes("main") ? mainProduct?.client?.title : "Районы"}</h1>
      <Calendar />
      <NumberOfMentions />
      {/*<TonalStatistic />*/}
      <MediaIndex />
      <BestSources />
      <PublicTop />
      {/*<BestThemes />*/}
      <Metrics />
    </div>
  );
}

export default Main;
